var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ivu-numeral"},[_vm._t("prefix",[_vm._v(_vm._s(_vm.prefix))]),_vm._v(_vm._s(_vm.currentValue)),_vm._t("suffix",[_vm._v(_vm._s(_vm.suffix))])],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/numeral/numeral.vue